import { useCallback, useEffect, useRef, useState } from 'react';
import './Intro.css';

const posterUrl = encodeURI('/assets/image copy 4.png');
const videoSources = ['/assets/PranavSharu-intro.mp4', '/assets/intro-birds-video.webm'];
const birdsVideoIndex = 1;

type IntroProps = {
  onFooterClick?: () => void;
  onPosterClick?: () => void;
};

function Intro({ onFooterClick, onPosterClick }: IntroProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const handleEnded = useCallback(() => {
    if (currentIndex < videoSources.length - 1) {
      setCurrentIndex((prev) => Math.min(prev + 1, videoSources.length - 1));
      return;
    }
  }, [currentIndex]);

  const playCurrentVideo = useCallback(() => {
    if (!videoRef.current) {
      return;
    }

    const playAttempt = videoRef.current.play();
    if (playAttempt && typeof playAttempt.then === 'function') {
      playAttempt.catch(() => {
        // Ignore play errors triggered by browser policies.
      });
    }
  }, []);

  const handlePosterClick = useCallback(() => {
    setHasStarted(true);
    setCurrentIndex(0);
    playCurrentVideo();
    if (onPosterClick) {
      onPosterClick();
    }
  }, [onPosterClick, playCurrentVideo]);

  const handleFooterClick = useCallback(() => {
    if (onFooterClick) {
      onFooterClick();
    }
  }, [onFooterClick]);

  useEffect(() => {
    if (!hasStarted) {
      return;
    }

    playCurrentVideo();
  }, [currentIndex, hasStarted, playCurrentVideo]);

  return (
    <main className="intro">
      <video
        ref={videoRef}
        className="intro-video"
        src={videoSources[currentIndex]}
        poster={posterUrl}
        preload="auto"
        muted
        playsInline
        onEnded={handleEnded}
      />
      <button
        type="button"
        className={`intro-poster${hasStarted ? ' intro-poster--hidden' : ''}`}
        onClick={handlePosterClick}
        aria-label="Play intro"
        aria-hidden={hasStarted}
        tabIndex={hasStarted ? -1 : 0}
        style={{ backgroundImage: `url("${posterUrl}")` }}
      />
      {currentIndex === birdsVideoIndex ? (
        <div className="intro-overlay">
          <div className="intro-center">
            <span className="intro-kicker">We're getting married!</span>
            <span className="intro-name">Pranav</span>
            <span className="intro-amp">&</span>
            <span className="intro-name">Sharu</span>
            <div className="intro-emblem">✦</div>
            
            <span className="intro-date">22 February 2026</span>
          </div>
          <button
            type="button"
            className="intro-footer"
            onClick={handleFooterClick}
            aria-label="Open countdown"
          >
            <span className="intro-footer-text">Exciting Details</span>
            <span className="intro-footer-arrow" />
          </button>
        </div>
      ) : null}
    </main>
  );
}

export default Intro;
